'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFileArrowCurvedRight, iconFileArrowCurvedRightTag } from '@ni/nimble-components/dist/esm/icons/file-arrow-curved-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFileArrowCurvedRight };
export { iconFileArrowCurvedRightTag };
export const NimbleIconFileArrowCurvedRight = wrap(IconFileArrowCurvedRight);